import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {HttpRequestOptions, ProductDetermination} from '@dcp/configurator';
import {Observable, throwError} from 'rxjs';
import {concatMap} from 'rxjs/operators';
import {DcpKymaService} from './dcp-kyma.service';

@Injectable({
  providedIn: 'root',
})
export class DcpProductDeterminationService {
  constructor(private http: HttpClient, private kymaService: DcpKymaService) {}

  getProductDetermination(
    technicalName: string = '',
    accountId?: string,
    userId?: string,
    materialFilter?: string[],
    slmId?: string,
    languageIso: string = 'en-US'
  ): Observable<ProductDetermination> {
    const body = {
      technicalName,
      ...(accountId && {accountId}),
      ...(userId && {userId}),
      ...(materialFilter && materialFilter.length > 0 && {materialFilter}),
      ...(slmId && {slmId}),
      ...(languageIso && {languageIso}),
    };
    return this.kymaService
      .prepareAuthConfig()
      .pipe(
        concatMap((config: HttpRequestOptions) =>
          this.http.post<ProductDetermination>(
            `${this.kymaService.getUrl('transaction')}/cta-product-determination`,
            body,
            config
          )
        )
      );
  }

  handleError(error: HttpErrorResponse) {
    return throwError(() => error);
  }
}
